"use strict";

$(document).ready(function () {
  var $forms = document.getElementsByClassName('needs-validation');
  var $formsChat = document.getElementsByClassName('needs-validations');
  var formsValidation = validationThisForm($forms);
  var formsChat = validationThisForm($formsChat);

  function validationThisForm(thisForm) {
    var validation = Array.prototype.filter.call(thisForm, function (thisForm) {
      thisForm.addEventListener('submit', function (e) {
        // Clear validation error messages
        $('.form-group').removeClass('field-error');
        $('.js-invalid-feedback-browser').hide(); // Add validation error messages

        var $invalidFields = $('input:invalid,select:invalid,textarea:invalid', thisForm);

        if ($invalidFields.length > 0) {
          e.preventDefault();
          $invalidFields.each(function () {
            var $field = $(this);
            var $parent = $field.parents('.form-group').first();
            $parent.addClass('field-error');
            $field.siblings('.invalid-feedback').show();
          });
        }
      });
    });
  }
});
$(document).ready(function () {
  $(document).on('change', '#attachment_image', function () {
    var thisInput = $(this);

    if ($(this)[0].files.length > 0) {
      var mainBlock = thisInput.parents('.cv-uploader ');
      var filesHolder = mainBlock.find('.cv-uploader-files-holder');
      thisInput.parents('label').addClass('file');
      updateFilesBlocks($(this)[0].files, filesHolder);
    }
  });

  if ($("#vat-country").length > 0) {
    $("#vat-country").select2({
      minimumResultsForSearch: -1,
      templateResult: function templateResult(idioma) {
        var $span = $("<span><img src='" + window.location.origin + "/themes/mpTheme/assets/flags/flag_" + idioma.id + ".svg'/></span>");
        return $span;
      },
      templateSelection: function templateSelection(idioma) {
        var $span = $("<span><img src='" + window.location.origin + "/themes/mpTheme/assets/flags/flag_" + idioma.id + ".svg'/></span>");
        return $span;
      }
    });
    $("#vat-country").data('select2').$dropdown.addClass('pvm_c');
  }

  $(document).on('click', '.cv-upload-file-remove', function () {
    var thisEl = $(this);
    var thisBlock = thisEl.parents('.cv-upload-file-block');
    var thisBlockNum = parseInt(thisBlock.attr('data-file-num'));
    var mainParent = thisEl.parents('.cv-uploader');
    var filesHolder = mainParent.find('.cv-uploader-files-holder');
    var fileInput = mainParent.find('input:file');
    var files = $(fileInput)[0].files;
    var filesLength = files.length;

    if (filesLength < 2) {
      $(filesHolder).empty();
      fileInput.parents('label').removeClass('file');
    } else {
      updateFileList($(fileInput)[0], thisBlockNum);
      $(filesHolder).empty();
      updateFilesBlocks(mainParent.find('input:file')[0].files, filesHolder);
    }
  });

  function updateFileList(fileField, index) {
    var fileBuffer = Array.from(fileField.files);
    fileBuffer.splice(index, 1);
    var dT = new ClipboardEvent('').clipboardData || // Firefox < 62 workaround exploiting https://bugzilla.mozilla.org/show_bug.cgi?id=1422655
    new DataTransfer(); // specs compliant (as of March 2018 only Chrome)

    for (var _i = 0, _fileBuffer = fileBuffer; _i < _fileBuffer.length; _i++) {
      var file = _fileBuffer[_i];
      dT.items.add(file);
    }

    fileField.files = dT.files;
  }

  function updateFilesBlocks(files, holder) {
    for (var i = 0; i < files.length; i++) {
      var fileBlock = $('<div class="cv-upload-file-block" data-file-num="' + i + '"></div>');
      var icon = $('<div class="icon"></div>');
      var name = $('<div class="name"></div>');
      name.text(files[i].name);
      var removeBtn = $('<div class="cv-upload-file-remove"></div>');
      fileBlock.append(icon);
      fileBlock.append(name);
      fileBlock.append(removeBtn);
      holder.append(fileBlock);
    }
  }

  $(document).on('click', '.cv-uploader-remove', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var thisBtn = $(this);
    var thisLabel = thisBtn.parents('label');
    var thisInput = thisLabel.find('input');
    var thisFileName = thisLabel.find('.cv-uploader-filename');
    thisInput.val('');
    thisFileName.text('');
    thisLabel.removeClass('file');
  });

  if ($('[type="date"]').prop('type') != 'date') {
    $('[type="date"]').datepicker();
  }
});